export default "<div class=\"bar\">\n  <p>{{string}}</p>\n</div>\n"